
import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { getAllAlternateUrls, getCanonicalUrl, getSocialMediaMetaData } from '~/helpers/metadata';
import LoginBase from '~/mixins/LoginBase';
import ContentNavigationB2B from '~/components/website/ContentNavigationB2B.vue';
import PopupHandler from '~/components/website/PopupHandler.vue';

const contentStore = namespace('b2b-content');

@Component({
	name: 'WebinarsPage',
	layout: 'content-company',
	components: {
		ContentNavigationB2B,
		ItemList: () => import('~/components/website/list/ItemList.vue'),
		PopupHandler,
		CallToAction: () => import('@hokify/shared-components/lib/components/CallToAction.vue')
	},
	head() {
		const path = `${this.$store.state.host}/business/webinars`;

		const canonical = getCanonicalUrl(path);
		const alternates = getAllAlternateUrls(path);
		const result: any = {
			title: 'Webinare',
			titleTemplate: '%s | hokify',
			link: [canonical, ...alternates],
			meta: [
				{ hid: 'robots', name: 'robots', content: 'index, follow' },
				{
					hid: 'description',
					name: 'description',
					content: 'Hier finden Sie eine Auflistung aller hokify Experten Webinare.'
				}
			]
		};

		result.meta.push(
			...getSocialMediaMetaData(
				result,
				this.$store.state.topLevelDomain,
				undefined,
				undefined,
				this.$route.query
			)
		);
		return result;
	},
	async asyncData({ store }) {
		await Promise.all([
			store.dispatch('b2b-content/loadUpcomingWebinars'),
			store.dispatch('b2b-content/loadPastWebinars')
		]);
	}
})
export default class WebinarsPage extends Mixins(LoginBase()) {
	mode = 'contact';

	articlesPerApiCall = 10;

	@contentStore.State('upcomingWebinarTeaser') upcomingWebinars;

	@contentStore.State('pastWebinarTeaser') pastWebinars;

	@contentStore.Action('loadUpcomingWebinars') loadUpcomingWebinars;

	@contentStore.Action('loadPastWebinars') loadPastWebinars;

	async loadMoreUpcomingWebinars(currentCount): Promise<boolean> {
		const webinarCount = await this.loadUpcomingWebinars({
			page: currentCount / this.articlesPerApiCall,
			limit: this.articlesPerApiCall
		});

		return webinarCount === this.articlesPerApiCall;
	}

	async loadMorePastWebinars(currentCount): Promise<boolean> {
		const webinarCount = await this.loadPastWebinars({
			page: currentCount / this.articlesPerApiCall,
			limit: this.articlesPerApiCall
		});

		return webinarCount === this.articlesPerApiCall;
	}
}
